import { UploadFileIcons } from "../constants/file-constant";

export const getFileIcon = (fileType) => {
  switch (fileType) {
    case "application/pdf":
      return UploadFileIcons.PDF;
    case "image/png":
      return UploadFileIcons.PNG;
    case "application/vnd.ms-excel":
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      return UploadFileIcons.XLS;
    default:
      return UploadFileIcons.PDF;
  }
}

export const formatBytes = (bytes) => {
  if (bytes < 1024) return bytes + " B";
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(0) + " KB";
  if (bytes < 1024 * 1024 * 1024) return (bytes / (1024 * 1024)).toFixed(0) + " MB";
  return (bytes / (1024 * 1024 * 1024)).toFixed(0) + " GB";
};

export const getFileNameFromUrl = (url) => {
  try {
    return decodeURIComponent(url.split("/").pop() || "");
  } catch {
    return "";
  }
}

export const getFileIconByExtension = (fileUrl) => {
    const extension = getFileNameFromUrl(fileUrl)
      .split(".")
      .pop()
      ?.toLowerCase();

    switch (extension) {
      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
        return "pi pi-image";
      case "pdf":
        return "pi pi-file-pdf";
      case "doc":
      case "docx":
        return "pi pi-file-word";
      case "xls":
      case "xlsx":
        return "pi pi-file-excel";
      case "ppt":
      case "pptx":
        return "pi pi-file";
      case "zip":
      case "rar":
        return "pi pi-file-zip";
      case "txt":
        return "pi pi-file";
      default:
        return "pi pi-file";
    }
  }